import { render } from "./BaseSlab.vue?vue&type=template&id=3743f562"
import script from "./BaseSlab.vue?vue&type=script&lang=js"
export * from "./BaseSlab.vue?vue&type=script&lang=js"

import "./BaseSlab.vue?vue&type=style&index=0&id=3743f562&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__